module.exports = __webpack_public_path__ + "static/img/B.M.W.33a43ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/B.M.W.png
// module id = bu+r
// module chunks = 1